/**
 * sessionStorage key of the zone monitoring's active sub-tab. MonitoringPage restores it on
 * mount; a drill-down from another page writes it before opening the monitoring tab
 * (`services/fleetDrillDown.openZoneMonitoring`).
 */
export const MONITORING_SUB_TAB_KEY = 'monitoring-sub-tab';
/** Navigating from modeless help can target a MonitoringPage that is already mounted. */
export const MONITORING_SUB_TAB_EVENT = 'gridpilot:monitoring-sub-tab';
